// extracted by mini-css-extract-plugin
export default {"custom_button":"Button_custom_button__wvoUU","link":"Button_link__mi+bP"};